import PAI_VALUE_LABELS from "./pai_value_labels.json";
import { appendAuthToUrl } from "./authUrl";

const API_URL = process.env.REACT_APP_API_URL || "";

/** Restituisce true se il PAI è stato inserito tramite upload file. */
export function isPaiUpload(pai) {
  return pai?.origine === "upload";
}

/** Restituisce true se il PAI è attestato in cartaceo (senza file digitale). */
export function isPaiCartaceo(pai) {
  return pai?.origine === "cartaceo";
}

/** PAI esterno al wizard (upload o cartaceo): niente modifica/stampa guidata. */
export function isPaiEsterno(pai) {
  return isPaiUpload(pai) || isPaiCartaceo(pai);
}

/** URL autenticato per aprire/scaricare il file di un PAI upload. */
export function getPaiFileUrl(fascicoloId, token) {
  return appendAuthToUrl(
    `${API_URL}/api/fascicoli-assistenziali/${fascicoloId}/pai/file`,
    token
  );
}

/** Valore uguale, etichetta diversa per campo (form PAI) */
const FIELD_VALUE_OVERRIDES = {
  "memoria|buona": "Buona, trattiene informazioni",
  "spostamenti|autonoma": "Deambulazione autonoma",
};

const INTERESSI_LABELS = {
  lettura: "Lettura",
  televisione: "Televisione",
  passatempi: "Passatempi",
  lavori_manuali: "Lavori manuali",
  uso_telefono: "Uso del telefono",
};

const AUSILI_LABELS = {
  bastone: "Bastone/Tripode",
  girello: "Girello",
  carrozzina: "Carrozzina",
  cuscino_antidecubito: "Cuscino antidecubito",
  materasso_antidecubito: "Materasso antidecubito",
};

/**
 * Converte un valore salvato (enum) nell'etichetta mostrata in compilazione.
 * @param {*} value
 * @param {string|null} fieldKey nome campo (es. "memoria") per eccezioni
 * @returns {string|null} null se vuoto
 */
export function formatPaiScalar(value, fieldKey = null) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "boolean") return value ? "Sì" : "No";
  const s = String(value);
  const okey = fieldKey ? `${fieldKey}|${s}` : null;
  if (okey && FIELD_VALUE_OVERRIDES[okey]) return FIELD_VALUE_OVERRIDES[okey];
  return PAI_VALUE_LABELS[s] || s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function displayPai(value, fieldKey = null) {
  const f = formatPaiScalar(value, fieldKey);
  return f === null ? "—" : f;
}

export function formatPaiList(arr) {
  if (!arr || !Array.isArray(arr) || arr.length === 0) return null;
  const parts = arr.map((x) => formatPaiScalar(x) || String(x));
  return parts.join(", ");
}

export function displayPaiList(arr) {
  return formatPaiList(arr) || "—";
}

export function formatAusili(ausili) {
  if (!ausili || typeof ausili !== "object") return null;
  const parts = [];
  for (const [key, cfg] of Object.entries(ausili)) {
    if (!cfg?.usa) continue;
    const label = AUSILI_LABELS[key] || key.replace(/_/g, " ");
    const prop = (cfg.proprietario || "").trim();
    const propLabel = prop ? formatPaiScalar(prop, "proprietario") : null;
    parts.push(propLabel ? `${label} (proprietario: ${propLabel})` : label);
  }
  return parts.length ? parts.join(", ") : null;
}

export function formatInteressi(interessi) {
  if (!interessi || typeof interessi !== "object") return null;
  const parts = [];
  for (const [k, v] of Object.entries(interessi)) {
    if (v === null || v === undefined || v === "") continue;
    const lab = INTERESSI_LABELS[k] || k.replace(/_/g, " ");
    parts.push(`${lab}: ${formatPaiScalar(v, k) || v}`);
  }
  return parts.length ? parts.join("; ") : null;
}
